import get from 'lodash/get';
import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { denormalize } from '../normalizr';
var _state_reduxKey;
export const getDataEntities = (state)=>(_state_reduxKey = state[reduxKey]) !== null && _state_reduxKey !== void 0 ? _state_reduxKey : {};
export const getDataEntityById = (state, entitySchema, id)=>{
    const entities = getAllDataEntitiesForSchema(state, entitySchema);
    if (entities) {
        return entities[id];
    }
};
export const getDataEntitiesByIds = (state, entitySchema, ids)=>{
    const entities = getAllDataEntitiesForSchema(state, entitySchema);
    if (entities) {
        return ids.map((id)=>entities[id]).filter((entity)=>!!entity);
    }
    return [];
};
export const getAllDataEntitiesForSchema = (state, entitySchema)=>get(state, `${reduxKey}.${entitySchema.key}`);
export const getAllDataEntitiesForSchemaArray = (state, entitySchema)=>{
    const entities = getAllDataEntitiesForSchema(state, entitySchema) || {};
    return Object.keys(entities).map((key)=>entities[key]);
};
/**
 * Important! Do not use any Denormalized selectors for components
 * It will cause re-rendering, because will be not optimized for reselect
 */ export const getDenormalizedDataEntityById = (state, entitySchema, id)=>denormalize(id, entitySchema, state[reduxKey]);
export const getAllDenormalizedDataEntitiesForSchema = (state, entitySchema /* should be schema.Entity, but even though schema.Entity has isAttribute, it is not a part of the interface. Sadface. */ )=>denormalize(Object.keys(get(state, `${reduxKey}.${entitySchema.key}`, {})), [
        entitySchema
    ], get(state, reduxKey)).reduce((result, entity)=>{
        // key by idAttribute
        const idAttribute = typeof entitySchema.idAttribute === 'function' ? 'id' : entitySchema.idAttribute;
        result[entity[idAttribute]] = entity;
        return result;
    }, {});
export const createGetDenormalizedDataEntitiesByIds = ()=>createSelector([
        (state, entitySchema, ids)=>getAllDenormalizedDataEntitiesForSchema(state, entitySchema),
        (state, entitySchema, ids)=>ids
    ], (allEntitiesKeyedByIds, ids)=>ids.map((id)=>allEntitiesKeyedByIds[id]).filter((i)=>i !== undefined));
export const getDenormalizedDataEntitiesByIds = createGetDenormalizedDataEntitiesByIds();
